import useFormatDate from '@/src/hooks/date/useFormatDate'
import { convertDDMMYYYYToISO } from '@/src/utils/date/convertDateFormat'
import { TransformedSegmentData } from '@/src/utils/itinerary/flightTransformers'
import { useTranslations } from 'next-intl'
import SegmentBlock from './segmentBlock'

interface SegmentBlockWrapperProps {
    segmentData: TransformedSegmentData
    showBaggageInfo?: boolean
}

const SegmentBlockWrapper = ({ segmentData, showBaggageInfo = true }: SegmentBlockWrapperProps) => {
    const { formatDate } = useFormatDate()

    const {
        departureTime,
        arrivalTime,
        arrivalDate,
        departureDate,
        departureAirport,
        departureTerminal,
        arrivalAirport,
        arrivalTerminal,
        duration,
        srpFlightDetails,
        operatingAirlineName,
        ...rest
    } = segmentData
    const t = useTranslations('common')

    const operatedBy = operatingAirlineName ? t('operatingAirlineName', { operatingAirlineName }) : ''

    const formattedDepartureAirport = t(
        `formattedAirportName${departureTerminal ? 'WithTerminal' : 'WithoutTerminal'}`,
        {
            airport: departureAirport,
            terminal: departureTerminal
        }
    )
    const formattedArrivalAirport = t(`formattedAirportName${arrivalTerminal ? 'WithTerminal' : 'WithoutTerminal'}`, {
        airport: arrivalAirport,
        terminal: arrivalTerminal
    })
    const formattedDuration = t('duration', {
        hours: duration.hours,
        minutes: duration.mins
    })
    // Format dates for display
    let departureDisplayDate = formatDate(departureTime, 'ddd, D MMM')
    let arrivalDisplayDate = formatDate(arrivalTime, 'ddd, D MMM')
    if (srpFlightDetails) {
        departureDisplayDate = departureDate ? formatDate(convertDDMMYYYYToISO(departureDate), 'ddd, D MMM') : ''
        arrivalDisplayDate = arrivalDate ? formatDate(convertDDMMYYYYToISO(arrivalDate), 'ddd, D MMM') : ''
    }
    return (
        <SegmentBlock
            departureTime={srpFlightDetails ? departureTime : formatDate(departureTime, 'HH:mm')}
            arrivalTime={srpFlightDetails ? arrivalTime : formatDate(arrivalTime, 'HH:mm')}
            departureDisplayDate={departureDisplayDate}
            arrivalDisplayDate={arrivalDisplayDate}
            departureAirport={formattedDepartureAirport}
            arrivalAirport={formattedArrivalAirport}
            duration={formattedDuration}
            showBaggageInfo={showBaggageInfo}
            operatedBy={operatedBy}
            {...rest}
        />
    )
}

export default SegmentBlockWrapper
